<template>
  <div class="main-wrapper scroll-y custom-scrollbar with-tabs view-ph-statistics">

    <page-title :title="'Statystyki'" :back="true"></page-title>

    <div v-for="(item, index) in statistics" :key="index">
      <item-statistic :index="index"
                      :title="item.title"
                      :subtitle="item.subtitle"
                      :value="item.value"
                      :unit="item.unit">
      </item-statistic>
    </div>

  </div>
</template>

<script>
  import { mapGetters, mapState } from 'vuex';
  import PageTitle from '@/components/PageTitle.vue';
  import ItemStatistic from '@/items/ItemStatistic.vue';

  export default {
    name: 'PhStatistics',
    components: { PageTitle, ItemStatistic },
    data(){
      return {
        show: false,
        searchbarActive: false
      }
    },
    computed: {
      ...mapGetters('profile', ['getProfile']),
      ...mapState({
        errors: state => state.clients.errors,
        loading: state => state.clients.loading,
        statistics: state => state.clients.statistics,
      })
    },
    mounted(){
      let payload = {'ph_slug' : this.getProfile.slug};
      this.$store.dispatch('clients/PH_STATISTICS_REQUEST', payload).then(() => {
        this.show = true
      })
    }
  }
</script>

<style lang="scss" scoped>
  ion-card-content{
    padding: 8px 12px;
  }
  ion-card-header{
    --background: #ffffff;
  }
</style>